import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Layout } from '../Layout';

export interface IRealtyValuationProps {
  title: string;
  content: React.ReactElement<any>;
}

export const RealtyValuationMobile: React.FC<IRealtyValuationProps> = props => {
  const { content, title } = props;

  return (
    <Layout>
      <div className={styles['title']}>
        <UIHeading2 as="h2">{title}</UIHeading2>
      </div>
      {content}
    </Layout>
  );
};
